import { MarketingConsentsAction, setClosedDialog } from "infrastructure/store/marketingConsents/MarketingConsentsActions";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import UserManager from "./UserManager";

interface IProps {}

const LogoutPage: React.FC<IProps> = (props) => {
  // store
  const consentsDispatch = useDispatch<Dispatch<MarketingConsentsAction>>();

  // state
  const [finishedLogoutActions, setFinishedLogoutActions] = useState(false);

  // side-effects - actions before logout
  useEffect(() => {
    consentsDispatch(setClosedDialog(false));
    // set "re-render" attribute after call logout actions
    // if there was a call directly, it did not log off user
    setFinishedLogoutActions(true);
  }, []);
  
  // render
  return (
    <>
      {finishedLogoutActions &&
        UserManager.signoutRedirect()
      }
    </>
  );
};

export default LogoutPage;
